import React, { useEffect, ReactNode, ComponentClass } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

export type OwnProps = {
    children?: ReactNode;
};

const _ScrollToTop = ({ children, location: { pathname } }: OwnProps & RouteComponentProps) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return <>{children}</>;
};

export const ScrollToTop = withRouter(_ScrollToTop) as ComponentClass<OwnProps>;
